import React from "react";

export const MoveNights: React.FunctionComponent = (props) => {
  return <>Move Nights</>;
};
